import { Doctor } from "./../../services/doctor";
import { WireCardAccount } from "./../../services/wire_card_account";
import { BankAccount } from "./../../services/bank_account";
import { centsToBRL } from "./../../utils/currency/convert";

export const state = {
  loading: false,
  transfer_history: [],
  institution_doctors: [],
  financials: {},
  bank_account: {},
  coupons: {},
  doctor_categories: {},
  balances: {
    current: [{ amount: 0 }],
    future: [{ amount: 0 }],
    unavailable: [{ amount: 0 }]
  }
};

export const mutations = {
  SET_BALANCES(state, payload) {
    state.balances = payload;
  },
  SET_BANK_ACCOUNT(state, payload) {
    state.bank_account = payload;
  },
  DELETE_BANK_ACCOUNT(state) {
    state.bank_account = {};
  },
  SET_TRANSFER_HISTORY(state, payload) {
    state.transfer_history = payload;
  },
  SET_FINANCIALS(state, payload) {
    state.financials = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_COUPONS(state, payload) {
    state.coupons = payload;
  },
  SET_INSTITUTION_DOCTORS(state, payload) {
    state.institution_doctors = payload;
  },
  SET_DOCTOR_CATEGORIES(state, payload) {
    state.doctor_categories = payload;
  }
};

export const getters = {
  balances(state) {
    return {
      available: state.balances.current[0].amount,
      future: state.balances.future[0].amount,
      unavailable: state.balances.unavailable[0].amount
    };
  },
  balancesFormated(state) {
    return {
      available: centsToBRL(state.balances.current[0].amount),
      future: centsToBRL(state.balances.future[0].amount),
      unavailable: centsToBRL(state.balances.unavailable[0].amount)
    };
  },
  financials(state) {
    return state.financials;
  },
  loading(state) {
    return state.loading;
  },
  coupons(state) {
    return state.coupon;
  },
  institution_doctors(state) {
    return state.institution_doctors;
  },
  doctor_categories(state) {
    return state.doctor_categories;
  }
};

export const actions = {
  sendSMStoDoctor({}, payload) {
    return Doctor.sendSMStoDoctor(payload);
  },
  fetchDoctors({}, payload) {
    return Doctor.all(payload);
  },

  getDoctorDetails({}, payload) {
    return Doctor.details(payload);
  },

  activateWireCardAccount({ commit }, payload) {
    return WireCardAccount.activate(payload)
      .then(response => {
        commit("user/ADD_ACCOUNT", response.data, { root: true });
        return response;
      })
      .catch(error => error);
  },

  updateDoctorProperties({ commit }, payload) {
    return Doctor.update(payload).then(() => {
      commit("user/UPDATE_DOCTOR_PROPERTY", payload, { root: true });
    });
  },

  fetchDoctorsAvailables({}, payload) {
    return Doctor.availables(payload);
  },

  fetchDoctorsAppointments({}, payload) {
    return Doctor.appointments(payload);
  },

  getBalances({ commit }) {
    commit("doctor/SET_LOADING", true, { root: true });
    return Doctor.balanceDetails()
      .then(response => {
        commit("doctor/SET_BALANCES", response.data, { root: true });
        commit("doctor/SET_LOADING", false, { root: true });
        return response;
      })
      .catch(error => error);
  },

  addBankAccount({ commit }, payload) {
    return new Promise((resolve, reject) => {
      BankAccount.save({ bank_account: payload })
        .then(response => {
          commit("doctor/SET_BANK_ACCOUNT", response.data, { root: true });
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getBankAccount({ commit }) {
    return BankAccount.fetch().then(response => {
      commit("doctor/SET_BANK_ACCOUNT", response.data, { root: true });
      return response;
    });
  },

  deleteBankAccount({ commit }) {
    return BankAccount.delete().then(response => {
      commit("doctor/DELETE_BANK_ACCOUNT", {}, { root: true });
      return response;
    });
  },

  bankTransfer({ dispatch }, payload) {
    return BankAccount.transfer(payload).then(() => {
      dispatch("getBalances");
      dispatch("transfers");
    });
  },

  transfers({ commit }) {
    return BankAccount.transfers().then(response => {
      commit("doctor/SET_TRANSFER_HISTORY", response.data, { root: true });
      return response;
    });
  },

  getFinancials({ commit }) {
    commit("doctor/SET_LOADING", true, { root: true });
    return BankAccount.financials().then(response => {
      commit("doctor/SET_FINANCIALS", response.data, { root: true });
      commit("doctor/SET_LOADING", false, { root: true });
      return response;
    });
  },

  getDoctorCoupons({ commit }, payload) {
    return Doctor.getCoupons(payload).then(response => {
      commit("doctor/SET_COUPONS", response.data, { root: true });
      return response;
    });
  },

  async fetchInstitutionDoctors({ commit }, params) {
    try {
      commit("SET_LOADING", true);
      const response = await Doctor.institutionDoctors(params);
      commit("SET_INSTITUTION_DOCTORS", response.data);
      return response;
    } catch (error) {
      console.error("fetchInstitutionDoctors error:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  fetchDoctorCategories({ commit }) {
    return Doctor.getDoctorCategories().then(response => {
      commit("SET_DOCTOR_CATEGORIES", response.data);
      return response;
    });
  }
};
